module.exports = __webpack_public_path__ + "static/oceneni-v-ramci-european-customer-centricity-awards-b00acedf329f4cf60f4c7f4ffd5968b4.jpg";